class FacetRemove extends HTMLElement {
    constructor() {
      super();
  
      // facet-remove properties
      this.filterLabel = this.dataset.filterLabel;
      this.filterValue = this.dataset.filterValue;
      this.facetType = this.dataset.facetType;
  
      this.querySelector("a").addEventListener("click", (event) => {
        event.preventDefault();
        const filters = document.querySelectorAll("collection-filters-form");
        var filterForm;
        filters.forEach((filter) => {
          if(this.facetType === "clear") {
            filter.clearInputs();
          } else {
            filter.unToggleFromFacet(this.filterLabel, this.filterValue);
          }
          const form = filter.querySelector("form");
          if(!filterForm) filterForm = form;
        });
  
        if(filterForm) {
          filterForm.dispatchEvent(new Event("input"));
        }
      });
  
      this.addTryOnFacetRemoveUrls(this.querySelectorAll(".facet-try-on__link"));
    }
  
    clearMobileFilters() {
      const mobileInputs = document.querySelectorAll(".mobile-filter-inputs");
      mobileInputs.forEach((input) => (input.checked = false));
    }
  
    addTryOnFacetRemoveUrls(facets) {
      const tryOnParam = location.search
        .substring(1)
        .split("&")
        .find((param) => param.includes("try-on-filter"));
  
      if (tryOnParam) {
        facets.forEach((facet) => {
          const href = window.location.href.replace(tryOnParam, "");
          facet.href = href;
        });
      }
    }
  }
  
  customElements.define("facet-remove", FacetRemove);